export default "__VITE_ASSET__DWN2a9_D__"